import {
  AtaReuniao,
  AtaReuniaoTrash,
  AtaReuniaoEditForm,
  AtaReuniaoCreateForm
} from "./ata-reuniao"
import {
  Notificacao,
  NotificacaoTrash,
  NotificacaoCreateForm,
  NotificacaoEditForm
} from "./notificacao"

import {
  DiarioOcorrencias,
  DiarioOcorrenciasTrash,
  DiarioOcorrenciasCreateForm,
  DiarioOcorrenciasEditForm
} from "./diario-ocorrencias"

import {
  ProrrogacaoContratual,
  ProrrogacaoContratualTrash,
  ProrrogacaoContratualCreateForm,
  ProrrogacaoContratualEditForm
} from "./prorrogacao-contratual"
import {
  TermoCircunstanciado,
  TermoCircunstanciadoTrash,
  TermoCircunstanciadoCreateForm,
  TermoCircunstanciadoEditForm
} from "./termo-circunstanciado"
export { default as Fiscalizacao } from "./Fiscalizacao"
export {
  AtaReuniao,
  AtaReuniaoTrash,
  AtaReuniaoEditForm,
  AtaReuniaoCreateForm,
  Notificacao,
  NotificacaoTrash,
  NotificacaoCreateForm,
  NotificacaoEditForm,
  DiarioOcorrencias,
  DiarioOcorrenciasTrash,
  DiarioOcorrenciasCreateForm,
  DiarioOcorrenciasEditForm,
  ProrrogacaoContratual,
  ProrrogacaoContratualTrash,
  ProrrogacaoContratualCreateForm,
  ProrrogacaoContratualEditForm,
  TermoCircunstanciado,
  TermoCircunstanciadoTrash,
  TermoCircunstanciadoCreateForm,
  TermoCircunstanciadoEditForm
}



// WEBPACK FOOTER //
// ./src/views/fiscalizacao/index.js